import { ReactElement } from 'react'
import { StyleProp, StyleSheet, TextStyle, View, ViewStyle } from 'react-native'
import { ButtonSize, Icon, IconName, Radius, Select, SelectProps, Spacing, Text } from 'zens-storybook'

const transparentColor = 'transparent'

const styles = StyleSheet.create({
  container: {
    width: 40,
  },
  value: {
    minWidth: 0,
    backgroundColor: transparentColor,
    borderColor: transparentColor,
  },
  arrow: {
    display: 'none',
  },
  content: {
    top: Spacing.XS,
    right: 0,
    borderTopWidth: 1,
    borderTopStartRadius: Radius.S,
    borderTopEndRadius: Radius.S,
  },
  outline: {
    borderColor: transparentColor,
  },
  option: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    marginRight: Spacing.XS,
  },
  text: {
    fontSize: 16,
  },
})

export interface Item {
  key: string
  title?: string
  icon?: IconName | ReactElement
  style?: StyleProp<ViewStyle>
  hoveredStyle?: StyleProp<ViewStyle>
  textStyle?: StyleProp<TextStyle>
  iconStyle?: StyleProp<TextStyle>
  disabled?: boolean
  testID?: string
}

interface Props
  extends Omit<
    SelectProps<string>,
    'value' | 'items' | 'valueStyle' | 'arrowStyle' | 'contentOutlineStyle' | 'contentContainerStyle' | 'filterSelected'
  > {
  items: Item[]
  size?: ButtonSize
}

const MenuMore = (props: Props) => {
  const { style, items, ...otherProps } = props

  const selectItems = [
    {
      value: 'more',
      render: () => <Icon name="dots" />,
    },
    ...items.map((item) => ({
      value: item.key,
      render: () => (
        <View style={styles.option} testID={item.testID}>
          {item.icon && typeof item.icon === 'string' ? (
            <Icon name={item.icon} size={18} style={[styles.icon, item.iconStyle]} />
          ) : (
            item.icon
          )}
          <Text style={[styles.text, item.textStyle]}>{item.title}</Text>
        </View>
      ),
      style: item.style,
      hoveredStyle: item.hoveredStyle,
      disabled: item.disabled,
    })),
  ]

  return (
    <Select
      style={[styles.container, style]}
      value="more"
      items={selectItems}
      valueStyle={styles.value}
      arrowStyle={styles.arrow}
      contentOutlineStyle={styles.outline}
      contentContainerStyle={styles.content}
      filterSelected
      {...otherProps}
    />
  )
}

export default MenuMore
